/**
 * tp-type-tester.js
 * Auto-sizes editable text to fill the container width.
 * Clears the font name on first interaction so users can type fresh.
 * Supports font variant switching via label row buttons.
 */
(function () {
  var wraps = document.querySelectorAll('[id^="tp-tester-wrap-"]');

  wraps.forEach(function (wrap) {
    var input = wrap.querySelector('[id^="tp-tester-input-"]');
    if (!input) return;

    var section = wrap.closest('.tp-tester-section');
    var isFirstInteraction = true;
    var rafPending = false;
    function waitForFontLoad(family) {
  if (!document.fonts || !document.fonts.load) {
    return Promise.resolve();
  }

  return document.fonts.load("120px " + family, input.textContent || input.getAttribute('data-placeholder') || 'Aa').then(function () {
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(resolve);
      });
    });
  });
}

    function fitText() {
      if (rafPending) return;
      rafPending = true;

      requestAnimationFrame(function () {
        rafPending = false;

        var wrapWidth = wrap.clientWidth;
        if (wrapWidth <= 0) return;

        var text = input.textContent || input.getAttribute('data-placeholder') || 'Aa';
        if (text.trim() === '') text = input.getAttribute('data-placeholder') || 'Aa';

        var low = 12;
        var high = 800;
        var iterations = 20;

        input.style.display = 'inline-block';
        input.style.whiteSpace = 'nowrap';

        for (var i = 0; i < iterations; i++) {
          var mid = (low + high) / 2;
          input.style.fontSize = mid + 'px';

          if (input.scrollWidth <= wrapWidth) {
            low = mid;
          } else {
            high = mid;
          }
        }

        input.style.fontSize = (low * 0.98) + 'px';
        input.style.display = 'block';
      });
    }

    /* Clear default text on first focus */
    input.addEventListener('focus', function () {
      input.classList.remove('waiting');
      input.classList.add('tp-typed');
      if (isFirstInteraction) {
        isFirstInteraction = false;
        input.textContent = '';
      }
    });

    /* Re-fit on every input */
    input.addEventListener('input', function () {
      fitText();
    });

    /* Re-fit on resize */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        fitText();
      });
      ro.observe(wrap);
    } else {
      window.addEventListener('resize', fitText);
    }

    /* Prevent Enter from creating line breaks */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    });

    input.classList.add('waiting');

var initialFamily = window.getComputedStyle(input).fontFamily;

waitForFontLoad(initialFamily).then(function () {
  fitText();
  input.classList.add('tp-ready');
}).catch(function () {
  fitText();
  input.classList.add('tp-ready');
});

    /* Font variant label row */
    if (section) {
      var variantRow = section.querySelector('[id^="tp-tester-variants-"]');
      if (variantRow) {
        var baseUrl = 'https://cdn.jsdelivr.net/gh/taylorpenton/font-hosting@main/';
        var buttons = variantRow.querySelectorAll('button');

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var fontName = btn.getAttribute('data-font-name');
            var fontUrl = btn.getAttribute('data-font-url');
            var familyId = 'TPTester-' + fontName.replace(/[^a-zA-Z0-9]/g, '');

            /* Load the font */
            var style = document.createElement('style');
            style.textContent = "@font-face { font-family: '" + familyId + "'; src: url('" + baseUrl + fontUrl + "') format('woff'); font-display: swap; }";
            document.head.appendChild(style);

            /* Apply to input */
input.classList.remove('tp-ready');
input.style.fontFamily = "'" + familyId + "', serif";
input.setAttribute('data-placeholder', fontName);
if (isFirstInteraction) {
  input.textContent = fontName;
}

/* Update active state */
buttons.forEach(function (b) { b.classList.remove('active'); });
btn.classList.add('active');

waitForFontLoad("'" + familyId + "', serif").then(function () {
  fitText();
  input.classList.add('tp-ready');
}).catch(function () {
  fitText();
  input.classList.add('tp-ready');
});
          });
        });
      }
    }
  });
})();
